import { HTMLProps } from "react";
import { cn } from "@/utils/helpers";
import styles from "./Columns.module.css";

export interface ColumnsProps extends HTMLProps<HTMLDivElement> {};

export default function Columns({
	children,
	className,
	...props
} : ColumnsProps) {
	return (
		<div
			className={cn(styles.Columns, className)}
			{...props}
		>
			{children}
		</div>
	);
};